import { render, staticRenderFns } from "./NextSceneButton.vue?vue&type=template&id=3be85182&scoped=true&"
import script from "./NextSceneButton.vue?vue&type=script&lang=ts&"
export * from "./NextSceneButton.vue?vue&type=script&lang=ts&"
import style0 from "./NextSceneButton.vue?vue&type=style&index=0&id=3be85182&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be85182",
  null
  
)

export default component.exports